/*=========================================================================================
  File Name: actions.js
  Namespace: iframes
  Description: Vuex Store - IFrame actions
==========================================================================================*/
import {
  getIFrame,
  createIFrame,
  editIFrame,
  listIFrames
} from '@/services/iframes.service'
import {
  adaptIFrameToStore
} from '@/services/adapters/iframeAdapter.js'
import {
  listFiles
} from '@/services/files.services.js'
import {
  shortenUUIDs
} from '@/utils/utils'

const actions = {
  async getIFrameAction({
    commit
  }, {
    iframeId
  }) {
    const response = await getIFrame({
      iframeId
    })
    if (response) {
      commit('STORE_CURRENT_IFRAME', response)
    }
    return response
  },
  async getAllIFrames({
    commit,
    rootGetters
  }, params = {}) {
    if (params.ids && params.ids.length > 20) {
      params.ids = shortenUUIDs(params.ids)
    }
    params.company = rootGetters['app/getSelectedCompanyName']
    const response = await listIFrames(params)
    if (response) {
      commit('STORE_LIST_IFRAMES', response)
    }
    return response
  },
  async saveIFrameToApi({
    commit,
    getters,
    rootState
  }) {
    let response
    if (getters.getCurrentIFrame.id) {
      response = await editIFrame({
        ...getters.getCurrentIFrame,
        files: getters.getCurrentIFrameFiles.map(f => f.id),
        iframeId: getters.getCurrentIFrame.id,
        company: rootState.app.company
      })
    } else {
      response = await createIFrame({
        ...getters.getCurrentIFrame,
        files: getters.getCurrentIFrameFiles.map(f => f.id),
        company: rootState.app.company
      })
    }
    commit('STORE_CURRENT_IFRAME', response)
    return response
  },
  saveIFrameToEdit({
    commit
  }, iframe) {
    commit('STORE_CURRENT_IFRAME', adaptIFrameToStore({
      data: iframe
    }))
  },
  saveIFrameToEntries({
    commit
  }, iframe) {
    commit('STORE_IFRAME_TO_LIST', {
      [iframe.id]: iframe
    })
  },
  resetCurrentIFrame({
    commit
  }) {
    commit('RESET_CURRENT_IFRAME')
  },
  async getAllIFrameFiles({
    commit
  }, files) {
    const response = await listFiles({
      ids: files
    })
    commit('STORE_CURRENT_IFRAME_FILES', response.results)
  },
}

export default actions
